import { useState } from "react";

export default function ChestionarLoadingPage({ hospitalLogo }: { hospitalLogo?: string }) {
  const [logoSrc, setLogoSrc] = useState(hospitalLogo || "/assets/logo/logo.png");

  return (
    <div className="min-h-screen w-full bg-gray-50 flex justify-center items-center px-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-md p-8 flex flex-col items-center animate-fade-in">

        {/* Logo */}
        <img
          src={logoSrc}
          onError={() => setLogoSrc("/assets/logo/logo.png")}
          alt="Hospital Logo"
          className="w-24 h-24 object-contain mb-6 animate-pulse"
        />

        {/* Loading Text */}
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-700 mb-2">
            Se încarcă…
          </p>
          <p className="text-sm text-gray-500">
            Vă rugăm să așteptați câteva momente.
          </p>
        </div>

        {/* Spinner */}
        <div className="mt-8">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>

      </div>
    </div>
  );
}
